import { useTranslation } from 'react-i18next';
import { APP_STORE_URL, PLAY_STORE_URL } from '../../../constants';
import { logEvent } from '../../../infra/firebase/analytics';
import { AnalyticsEvent } from '../../../domain/analytics';
import styles from './StoreLinksSection.module.css';

function AppleGlyph() {
  return (
    <svg className={styles.glyph} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M16.365 1.43c0 1.14-.493 2.27-1.177 3.08-.744.9-1.99 1.57-2.987 1.57-.12 0-.23-.02-.3-.03-.01-.06-.04-.22-.04-.39 0-1.13.572-2.27 1.206-2.98.804-.94 2.142-1.64 3.248-1.68.03.13.05.28.05.43zm4.565 15.71c-.03.07-.463 1.58-1.518 3.12-.945 1.34-1.94 2.71-3.43 2.74-1.517.03-1.94-.84-3.91-.84-1.97 0-2.4.81-3.83.87-1.517.06-2.67-1.44-3.61-2.83-1.91-2.81-3.37-7.94-1.4-11.4.97-1.72 2.7-2.81 4.59-2.84 1.46-.03 2.84.97 3.74.97.89 0 2.56-1.2 4.32-1.02.73.03 2.79.29 4.11 2.21-.11.07-2.45 1.42-2.42 4.25.03 3.38 2.96 4.5 3 4.51z" />
    </svg>
  );
}

function PlayGlyph() {
  return (
    <svg className={styles.glyph} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M4 2.5v19a1 1 0 0 0 1.52.86l15.5-9.5a1 1 0 0 0 0-1.72L5.52 1.64A1 1 0 0 0 4 2.5z" />
    </svg>
  );
}

export default function StoreLinksSection() {
  const { t } = useTranslation('landing');

  return (
    <section className={styles.section} aria-labelledby="store-links-heading">
      <div className={styles.inner}>
        <p className={styles.eyebrow}>{t('storeLinks.eyebrow')}</p>
        <h2 id="store-links-heading" className={styles.heading}>
          {t('storeLinks.heading')}
        </h2>
        <p className={styles.body}>{t('storeLinks.body')}</p>

        <div className={styles.badges}>
          <a
            className={styles.badge}
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('storeLinks.appStore.alt')}
            onClick={() => logEvent(AnalyticsEvent.landingAppStoreClick)}
          >
            <AppleGlyph />
            <span className={styles.badgeText}>
              <span className={styles.badgeLabel}>{t('storeLinks.appStore.label')}</span>
              <span className={styles.badgeName}>{t('storeLinks.appStore.name')}</span>
            </span>
          </a>

          <a
            className={styles.badge}
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('storeLinks.playStore.alt')}
            onClick={() => logEvent(AnalyticsEvent.landingPlayStoreClick)}
          >
            <PlayGlyph />
            <span className={styles.badgeText}>
              <span className={styles.badgeLabel}>{t('storeLinks.playStore.label')}</span>
              <span className={styles.badgeName}>{t('storeLinks.playStore.name')}</span>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
